import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=220b3635&scoped=true&"
import script from "./TabView.vue?vue&type=script&lang=ts&"
export * from "./TabView.vue?vue&type=script&lang=ts&"
import style0 from "./TabView.vue?vue&type=style&index=0&id=220b3635&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b3635",
  null
  
)

export default component.exports